<template lang="pug">
  main
    aside
    div(class="centered")
      img(
        v-if="!hideLoading"
        src="@/assets/loading.gif"
        class="img-loading")
      h4 {{ loadingMsg }}
</template>

<script>
export default {
  name: "FileDownload",
  data() {
    return {
      loadingMsg: "Please wait while loading...",
      hideLoading: false
    };
  },

  mounted() {
    const urlDownload = `https://s3-us-west-2.amazonaws.com/hvullc.com/docs/${this.$route.params.id}`;
    window.location = urlDownload;
  },

  methods: {
    fileExists() {
      try {
        const xhr = new XMLHttpRequest();
        const urlCheck = `https://hvullc.com.s3.amazonaws.com/docs/${this.$route.params.id}`;
        const urlDownload = `https://s3-us-west-2.amazonaws.com/hvullc.com/docs/${this.$route.params.id}`;

        xhr.open("HEAD", urlCheck, false);
        xhr.send();

        if (xhr.status === 200) {
          window.location = urlDownload;
        } else {
          this.loadingMsg = "File not found.";
          this.hideLoading = true;
          window.location = "https://hvullc-dev.firebaseapp.com";
        }
      } catch (err) {
        this.loadingMsg = err.message;
      }
    }
  }
};
</script>

<style>
.centered {
  display: grid;
  place-content: center;
  text-align: center;
  width: 100%;
  height: 50vh;
}

.img-loading {
  margin: auto;
}
</style>
